import React from 'react';
import { Card } from 'react-bootstrap';

import PaisesOptions from '../../../support/catalogos/pagosaextranjeros/PaisesOptions';
import ConceptoPagoOptions from '../../../support/catalogos/pagosaextranjeros/ConceptoPagoOptions';
import { renderLegends } from '../../../../support/SingleLeyendLabel';
import ComplementoSummaryActionButtons from '../components/ComplementoSummaryActionButtons';

const ComplementoPagosaextranjerosResumen = ({ data = [], onEdit, onDelete, onListChange }) => {
  let Paises, ConceptoPagoLabel = {};

  if (data.EsBenefEfectDelCobro === 'NO') {
    Paises = PaisesOptions.filter(
      PaisesOptions =>
      PaisesOptions.value === data.NoBeneficiario.PaisDeResidParaEfecFisc);

    data.Pais = Paises[0].label;

    ConceptoPagoLabel = ConceptoPagoOptions.filter(
      ConceptoPagoOptions =>
      ConceptoPagoOptions.value === data.NoBeneficiario.ConceptoPago);

    data.ConceptoPago = ConceptoPagoLabel[0].label;
  }

  if (data.EsBenefEfectDelCobro === 'SI') {
    ConceptoPagoLabel = ConceptoPagoOptions.filter(
      ConceptoPagoOptions =>
      ConceptoPagoOptions.value === data.Beneficiario.ConceptoPago);

    data.ConceptoPago = ConceptoPagoLabel[0].label;
  }

  const handleOnDelete = () => {
    onDelete('Pagosaextranjeros');
  }

  const handleOnEdit = () => {
    onEdit('Pagosaextranjeros', data);
  }

  return (
    <Card>
      <Card.Body>
        <Card.Subtitle className="text-center">Pagos a Extranjeros, Versión { data.Version }</Card.Subtitle>

        { data.EsBenefEfectDelCobro === 'NO' && (
          labelsNoBeneficiario.map(renderLegends(data))
        )}

        { data.EsBenefEfectDelCobro === 'SI' && (
          labelsBeneficiario.map(renderLegends(data))
        )}

        <ComplementoSummaryActionButtons onEdit={ handleOnEdit} onDelete={ handleOnDelete } />

      </Card.Body>
    </Card>
  )
}

const labelsBeneficiario = [
  {
    label: 'Emisor es beneficiario del pago',
    index: 'EsBenefEfectDelCobro'
  },
  {
    label: 'Razón social',
    index: 'Beneficiario.NomDenRazSocB'
  },
  {
    label: 'RFC',
    index: 'Beneficiario.RFC'
  },
  {
    label: 'CURP',
    index: 'Beneficiario.CURP'
  },
  {
    label: 'Tipo de contribuyente',
    index: 'ConceptoPago'
  },
  {
    label: 'Concepto',
    index: 'Beneficiario.DescripcionConcepto'
  }
];

const labelsNoBeneficiario = [
  {
    label: 'Emisor es beneficiario del pago',
    index: 'EsBenefEfectDelCobro'
  },
  {
    label: 'País de residencia del extranjero',
    index: 'Pais',
  },
  {
    label: 'Tipo de contribuyente',
    index: 'ConceptoPago'
  },
  {
    label: 'Concepto',
    index: 'NoBeneficiario.DescripcionConcepto'
  }
];


export default ComplementoPagosaextranjerosResumen
